import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import DeviceScreenLayout from '../layouts/DeviceScreenLayout';

const shimmer = {
    background: 'linear-gradient(90deg, #EFEFEF 25%, #E2E2E2 50%, #EFEFEF 75%)',
    backgroundSize: '200% 100%',
    animation: 'skeleton-shimmer 1.4s infinite',
    borderRadius: 8,
};

const AgentSkeleton = () => (
    <>
        <style>{`
            @keyframes skeleton-shimmer {
                0%   { background-position: 200% 0; }
                100% { background-position: -200% 0; }
            }
        `}</style>
        <DeviceScreenLayout>
            <div style={{ width: '100%', height: '100%', position: 'relative', background: '#fff' }}>
                {/* 헤더 스켈레톤 */}
                <div style={{
                    width: '100%', height: 60,
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '0 24px',
                    borderBottom: '1px solid #F5F5F5',
                }}>
                    <div style={{ ...shimmer, width: 36, height: 36, borderRadius: '50%' }} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ ...shimmer, width: 36, height: 36, borderRadius: '50%' }} />
                        <div style={{ ...shimmer, width: 120, height: 16 }} />
                    </div>
                    <div style={{ ...shimmer, width: 24, height: 24, borderRadius: 6 }} />
                </div>

                {/* 메인 영역: 애니메이션 자리 */}
                <div style={{
                    position: 'absolute',
                    top: 60, left: 0,
                    width: '100%', height: 'calc(100% - 60px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <div style={{
                        ...shimmer,
                        width: 460, height: 460,
                        borderRadius: '50%',
                        opacity: 0.5,
                    }} />
                </div>
            </div>
        </DeviceScreenLayout>
    </>
);

const ProtectedRoute = ({ children }) => {
    const { isLoggedIn, isAuthChecking } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!isAuthChecking && !isLoggedIn) {
            toast.error("로그인이 필요한 서비스에요!", {
                id: "auth-shield",
                position: "bottom-center",
                icon: null,
                style: {
                    padding: '6px 8px',
                    color: '#FFFFFFDD',
                    fontFamily: 'Pretendard',
                    fontSize: '12px',
                    borderRadius: '4px',
                    backgroundColor: '#000000DD',
                    lineHeight: 1.0,
                    boxShadow: '0 4px 12px rgba(137, 136, 255, 0.2)',
                },
            });
        }
    }, [isAuthChecking, isLoggedIn]);

    if (isAuthChecking) return <AgentSkeleton />;

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
